module.exports = {"431124001":"濂溪街道","431124002":"西洲街道","431124003":"上关街道","431124004":"营江街道","431124005":"东门街道","431124006":"富塘街道","431124007":"万家庄街道","431124101":"梅花镇","431124102":"寿雁镇","431124103":"仙子脚镇","431124104":"清塘镇","431124105":"祥霖铺镇","431124106":"蚣坝镇","431124107":"四马桥镇","431124108":"白马渡镇","431124109":"柑子园镇","431124111":"白芒铺镇","431124112":"桥头镇","431124201":"乐福堂乡","431124210":"审章塘瑶族乡","431124212":"横岭瑶族乡","431124213":"洪塘营瑶族乡","431124402":"道县大坪铺农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431124.json
// module id = 1908
// module chunks = 0